import React from 'react';
import PropTypes from 'prop-types';

export const SvgX = ({ width, height, stroke, ...props }) => (
  <svg
    width={width || '10px'}
    height={height || '10px'}
    viewBox="0 0 10 10"
    version="1.1"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g
        transform="translate(-798.000000, -297.000000)"
        stroke={stroke || '#000000'}
        strokeWidth="2"
      >
        <g transform="translate(185.000000, 263.000000)">
          <g transform="translate(606.000000, 27.000000)">
            <path d="M16,8 L8,16 M8,8 L16,16" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgX.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
